import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import { api, formatApiErrorDetail, getToken, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=loading, false=anon, obj=logged
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!getToken()) {
      setUser(false);
      return null;
    }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      return r.data;
    } catch {
      setToken(null);
      setUser(false);
      return null;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    setError(null);
    try {
      const r = await api.post("/auth/login", { email, password });
      if (r.data?.access_token) setToken(r.data.access_token);
      const me = await refresh();
      return { ok: true, user: me };
    } catch (e) {
      const msg = formatApiErrorDetail(e?.response?.data?.detail) || e.message;
      setError(msg);
      return { ok: false, error: msg };
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    setToken(null);
    setUser(false);
  };

  const isAdmin = user && user !== false && user.role === "platform_admin";

  return (
    <AuthContext.Provider
      value={{ user, error, login, logout, refresh, isAdmin }}
    >
      {children}
    </AuthContext.Provider>
  );
};
